<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right">
        <el-button  type="success"  @click="onCustomTable" >动态明细列</el-button>
        <el-button  type="success" plain @click="onExport1" >导出明细</el-button>
        <el-button  type="success" plain @click="onExport2" >导出汇总</el-button>
      </template>
    </list>
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/fund/contactcash/inledgerdts/list";
export default {
  name: "receipt",
  mixins: [curdMixins],
  components: {
    list,
  },
  data() {
    return {
      api: require("@/api/fund/receipt").default,
    }
  },
  methods: {
    onExport1() {
      this.$confirm("是否导出明细？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$refs.list.onExport1();
      })
        .catch(() => {});
    },
    onExport2() {
      this.$confirm("是否导出汇总？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$refs.list.onExport2();
      })
        .catch(() => {});
    },
    onCustomTable(){
      this.$refs.list.onCustomTable();
    }
  }
};
</script>